import { Component, ComponentRef, Input, OnDestroy, OnInit, ViewChild, ViewContainerRef, inject } from '@angular/core';

import { Equipment, Plan } from '@bytel/bytel-sales';

import { ConfigurationService } from '@services/configuration.service';
import { Ftth3ClicsService } from '@services/ftth3-clics.service';
import { MainCartService } from '@services/main-cart.service';

import { Subscription } from 'rxjs';

import { ProductMapping } from '../../../catalog/product-mapping';
import { NavigateToDirective } from '../../../common/directives/navigate-to.directive';
import { EquipmentBlockDirective } from './equipment-block.directive';
import { EquipmentComponent } from './equipment/equipment.component';

@Component({
    selector: 'checkout-equipment-block',
    templateUrl: './equipment-block.component.html',
    styleUrl: 'equipment-block.component.scss',
    standalone: true,
    imports: [NavigateToDirective, EquipmentBlockDirective],
})
export class EquipmentBlockComponent implements OnInit, OnDestroy {
    @ViewChild(EquipmentBlockDirective, { static: true }) subscriptionHost: EquipmentBlockDirective;
    @Input() public quoteIndex: number = 0;

    public equipment: Equipment;
    public cartQuoteSubscription: Subscription;
    public editUrl: string;
    public showDeleteButton: boolean = true;

    private cartService: MainCartService = inject(MainCartService);
    private configurationService: ConfigurationService = inject(ConfigurationService);
    private ftth3ClicsService: Ftth3ClicsService = inject(Ftth3ClicsService);

    public ngOnInit(): void {
        const quote = this.cartService.getQuote(this.quoteIndex);
        this.equipment = quote.getPrincipalProduct<Equipment>('Equipment');
        this._loadComponent();
        this._updateOnQuoteChange();
        const isRenewal: boolean = quote.isRenewal();
        const plan = quote.getPrincipalProduct<Plan>('Plan');
        const accessories = quote.getProductsByType('Accessory');
        const isAccessoryInAutoAdd = accessories?.some((accessory) =>
            plan?.autoAdd?.includes(accessory?.data?.gencode),
        );
        this.showDeleteButton = !isRenewal && !isAccessoryInAutoAdd;
        let wallUrl: string = this.equipment.wallurl;
        if (isRenewal) {
            wallUrl = 'renewal';
        }
        let url: string = this.configurationService.getData()?.global.wall[wallUrl];
        if (plan?.data?.sub_type_id === 'swappy') {
            url += '/filtre/smart-change';
        }
        this.editUrl = url;
    }

    public ngOnDestroy(): void {
        this.cartQuoteSubscription.unsubscribe();
    }

    public remove(): void {
        this.stopUsingFtth3Clics();
        this.cartService.removeProduct(this.equipment, this.quoteIndex).subscribe();
    }

    public stopUsingFtth3Clics(): void {
        this.ftth3ClicsService.stopUsingFtth3Clics();
    }

    private _loadComponent(): void {
        const viewContainerRef: ViewContainerRef = this.subscriptionHost.viewContainerRef;
        viewContainerRef.clear();
        const component = ProductMapping.getComponent(this.equipment);
        const componentRef: ComponentRef<EquipmentComponent> = viewContainerRef.createComponent(component);
        componentRef.instance.quoteIndex = this.quoteIndex;
    }

    private _updateOnQuoteChange(): void {
        this.cartQuoteSubscription = this.cartService.cartQuoteSubscription.subscribe((quoteIndex) => {
            const equipment: Equipment = this.cartService.getQuote(quoteIndex).getPrincipalProduct<Equipment>('Equipment');
            if (equipment && quoteIndex === this.quoteIndex) {
                this.equipment = equipment;
                this._loadComponent();
            }
        });
    }
}
